module.exports = __webpack_public_path__ + "img/img-fde97da1.2418a928.png";